import { NgClass, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../services/language-service';

@Component({
  selector: 'ten-basic-info-dialog-cross',
  templateUrl: './basic-info-dialog-cross.component.html',
  styleUrls: ['./basic-info-dialog-cross.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatDialogModule, NgClass, NgIf, MatLegacyButtonModule, TranslateModule, MatIconModule],
})
export class BasicInfoDialogCrossComponent implements OnInit {
  public rightToLeftSite: boolean;
  public showCross = true;

  constructor(
    private cdr: ChangeDetectorRef,
    private languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.rightToLeftSite = this.languageService.isRtlLanguage();
    if (Object.prototype.hasOwnProperty.call(data, 'showCross')) {
      this.showCross = data.showCross;
    }
  }

  public ngOnInit() {
    this.cdr.detectChanges();
  }
}
